import { SVGProps } from "react";

export function WarningIcon({
    viewBox = "0 0 57 19",
    fill = "none",
    stroke = "#ADB3BC",
    strokeWidth = 1,
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" fill="#F04438" />
            <path d="M8 5.2V8M8 10.8H8.007M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#FCFCFD" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
}

export function WarningBladeIcon({
    viewBox = "0 0 57 19",
    fill = "none",
    stroke = "#ADB3BC",
    strokeWidth = 1,
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.83325" y="4" width="53.3333" height="53.3333" rx="26.6667" fill="#FEF0C7" />
            <rect x="3.83325" y="4" width="53.3333" height="53.3333" rx="26.6667" stroke="#FFFAEB" stroke-width="6.66667" />
            <g clip-path="url(#clip0_23193_155837)">
                <path d="M30.4998 26.2217V30.6662M30.4998 35.1106H30.5109M28.5998 20.5106L19.1887 36.2217C18.9946 36.5578 18.892 36.9387 18.8909 37.3268C18.8898 37.7148 18.9903 38.0963 19.1825 38.4334C19.3746 38.7705 19.6517 39.0515 19.9861 39.2482C20.3205 39.445 20.7007 39.5508 21.0887 39.5551H39.9109C40.2989 39.5508 40.679 39.445 41.0134 39.2482C41.3479 39.0515 41.6249 38.7705 41.8171 38.4334C42.0092 38.0963 42.1098 37.7148 42.1087 37.3268C42.1076 36.9387 42.0049 36.5578 41.8109 36.2217L32.3998 20.5106C32.2017 20.1841 31.9228 19.9141 31.59 19.7267C31.2572 19.5394 30.8817 19.4409 30.4998 19.4409C30.1179 19.4409 29.7424 19.5394 29.4096 19.7267C29.0768 19.9141 28.7979 20.1841 28.5998 20.5106Z" stroke="#DC6803" stroke-width="2.22222" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_23193_155837">
                    <rect width="26.6667" height="26.6667" fill="white" transform="translate(17.1666 17.3335)" />
                </clipPath>
            </defs>
        </svg>
    );
}
